<template>
  <div class="user-menu" v-if="menuUserNavBarVisible">
    <ul class="list"><slot></slot></ul>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'UserMenu',

  computed: {
    ...mapState('dashboard', [
      'menuUserNavBarVisible',
    ]),
  },
};
</script>

<style lang="scss" scoped>
  .user-menu {
    width: 160px;
    align-items: flex-end;
    justify-content: flex-start;
    border-color: #e2e8f0;
    position: absolute;
    display: flex;
    flex-direction: column;
    min-width: 1px;
    min-height: 1px;
    top: 100%;
    right: 0;
    z-index: 22;

    .list {
      background: #fff;
      box-shadow: 0 0 10px rgba(89,102,122,0.3);
      border-color: #e2e8f0;
      box-sizing: border-box;
      display: flex;
      overflow: auto;
      -webkit-overflow-scrolling: touch;
      max-height: calc(100vh - 48px);
      border-radius: 4px;
      outline: 0;
      flex-wrap: wrap;
      list-style: none;
      padding: 10px;
    }
  }
</style>
